import backgroundTextureBlush from 'assets/images/vxl/component/celebrationScreen/background-texture-blush.png';
import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageSourcePropType, StyleSheet, View } from 'react-native';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import CelebrationScreen from 'shared/patterns/vxl/CelebrationScreen/CelebrationScreen';

const OpenSavingsSuccess = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('accounts', {
    keyPrefix: 'openSavings',
  });

  const goToHomeAnalytics = usePressableAnalytics({
    analyticsId: 'savingsGoToHomeClicked',
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <CelebrationScreen
        illustrationKey="SAVINGS_APPROVAL_A_ANIMATED"
        illustrationAccessibilityLabel="Savings account approval celebration animation"
        backgroundTexture={backgroundTextureBlush as ImageSourcePropType}
        bodyText={translatedText('yourSavingIsApproved')}
        button={{
          label: translatedText('done'),
          onPress: () => {
            goToHomeAnalytics();
            router.replace('/open-savings/fund-savings-account');
          },
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default OpenSavingsSuccess;
